/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { EmptyResponse } from '../models/empty-response';
import { GrantListResponse } from '../models/grant-list-response';
import { identityControllerActivate } from '../fn/identity/identity-controller-activate';
import { IdentityControllerActivate$Params } from '../fn/identity/identity-controller-activate';
import { identityControllerAssignRegistry } from '../fn/identity/identity-controller-assign-registry';
import { IdentityControllerAssignRegistry$Params } from '../fn/identity/identity-controller-assign-registry';
import { identityControllerAssignRole } from '../fn/identity/identity-controller-assign-role';
import { IdentityControllerAssignRole$Params } from '../fn/identity/identity-controller-assign-role';
import { identityControllerChangePassword } from '../fn/identity/identity-controller-change-password';
import { IdentityControllerChangePassword$Params } from '../fn/identity/identity-controller-change-password';
import { identityControllerConnectReports } from '../fn/identity/identity-controller-connect-reports';
import { IdentityControllerConnectReports$Params } from '../fn/identity/identity-controller-connect-reports';
import { identityControllerConnectUsers } from '../fn/identity/identity-controller-connect-users';
import { IdentityControllerConnectUsers$Params } from '../fn/identity/identity-controller-connect-users';
import { identityControllerCreate } from '../fn/identity/identity-controller-create';
import { IdentityControllerCreate$Params } from '../fn/identity/identity-controller-create';
import { identityControllerDelete } from '../fn/identity/identity-controller-delete';
import { IdentityControllerDelete$Params } from '../fn/identity/identity-controller-delete';
import { identityControllerDevices } from '../fn/identity/identity-controller-devices';
import { IdentityControllerDevices$Params } from '../fn/identity/identity-controller-devices';
import { identityControllerForgotPassword } from '../fn/identity/identity-controller-forgot-password';
import { IdentityControllerForgotPassword$Params } from '../fn/identity/identity-controller-forgot-password';
import { identityControllerGetAll } from '../fn/identity/identity-controller-get-all';
import { IdentityControllerGetAll$Params } from '../fn/identity/identity-controller-get-all';
import { identityControllerGetGrants } from '../fn/identity/identity-controller-get-grants';
import { IdentityControllerGetGrants$Params } from '../fn/identity/identity-controller-get-grants';
import { identityControllerGetMyself } from '../fn/identity/identity-controller-get-myself';
import { IdentityControllerGetMyself$Params } from '../fn/identity/identity-controller-get-myself';
import { identityControllerGetOne } from '../fn/identity/identity-controller-get-one';
import { IdentityControllerGetOne$Params } from '../fn/identity/identity-controller-get-one';
import { identityControllerLogin } from '../fn/identity/identity-controller-login';
import { IdentityControllerLogin$Params } from '../fn/identity/identity-controller-login';
import { identityControllerLogout } from '../fn/identity/identity-controller-logout';
import { IdentityControllerLogout$Params } from '../fn/identity/identity-controller-logout';
import { identityControllerMfaSetup } from '../fn/identity/identity-controller-mfa-setup';
import { IdentityControllerMfaSetup$Params } from '../fn/identity/identity-controller-mfa-setup';
import { identityControllerMfaVerify } from '../fn/identity/identity-controller-mfa-verify';
import { IdentityControllerMfaVerify$Params } from '../fn/identity/identity-controller-mfa-verify';
import { identityControllerProfilePicture } from '../fn/identity/identity-controller-profile-picture';
import { IdentityControllerProfilePicture$Params } from '../fn/identity/identity-controller-profile-picture';
import { identityControllerRefreshSession } from '../fn/identity/identity-controller-refresh-session';
import { IdentityControllerRefreshSession$Params } from '../fn/identity/identity-controller-refresh-session';
import { identityControllerResetMfa } from '../fn/identity/identity-controller-reset-mfa';
import { IdentityControllerResetMfa$Params } from '../fn/identity/identity-controller-reset-mfa';
import { identityControllerResetPassword } from '../fn/identity/identity-controller-reset-password';
import { IdentityControllerResetPassword$Params } from '../fn/identity/identity-controller-reset-password';
import { identityControllerRevokeDevice } from '../fn/identity/identity-controller-revoke-device';
import { IdentityControllerRevokeDevice$Params } from '../fn/identity/identity-controller-revoke-device';
import { identityControllerSetActive } from '../fn/identity/identity-controller-set-active';
import { IdentityControllerSetActive$Params } from '../fn/identity/identity-controller-set-active';
import { identityControllerUpdate } from '../fn/identity/identity-controller-update';
import { IdentityControllerUpdate$Params } from '../fn/identity/identity-controller-update';
import { identityControllerUpdateMyself } from '../fn/identity/identity-controller-update-myself';
import { IdentityControllerUpdateMyself$Params } from '../fn/identity/identity-controller-update-myself';
import { identityControllerUserHasGrants } from '../fn/identity/identity-controller-user-has-grants';
import { IdentityControllerUserHasGrants$Params } from '../fn/identity/identity-controller-user-has-grants';
import { LoginResponse } from '../models/login-response';
import { MfaSetupResponse } from '../models/mfa-setup-response';
import { SessionResponse } from '../models/session-response';
import { UserDeviceListResponse } from '../models/user-device-list-response';
import { UserItem } from '../models/user-item';
import { UserResponse } from '../models/user-response';

@Injectable({ providedIn: 'root' })
export class IdentityService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `identityControllerGetGrants()` */
  static readonly IdentityControllerGetGrantsPath = '/identity/grants';

  /**
   * Recupera tutti i grant dell'utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerGetGrants()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerGetGrants$Response(params?: IdentityControllerGetGrants$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: GrantListResponse;
}>> {
    return identityControllerGetGrants(this.http, this.rootUrl, params, context);
  }

  /**
   * Recupera tutti i grant dell'utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerGetGrants$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerGetGrants(params?: IdentityControllerGetGrants$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: GrantListResponse;
}> {
    return this.identityControllerGetGrants$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: GrantListResponse;
}>): BaseResponse & {
'data'?: GrantListResponse;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerGetAll()` */
  static readonly IdentityControllerGetAllPath = '/identity';

  /**
   * Restituisce l'elenco degli utenti.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerGetAll$Response(params: IdentityControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserResponse;
}>> {
    return identityControllerGetAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco degli utenti.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerGetAll(params: IdentityControllerGetAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserResponse;
}> {
    return this.identityControllerGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserResponse;
}>): BaseResponse & {
'data'?: UserResponse;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerCreate()` */
  static readonly IdentityControllerCreatePath = '/identity';

  /**
   * Crea un utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerCreate$Response(params: IdentityControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>> {
    return identityControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerCreate(params: IdentityControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserItem;
}> {
    return this.identityControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>): BaseResponse & {
'data'?: UserItem;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerAssignRegistry()` */
  static readonly IdentityControllerAssignRegistryPath = '/identity/registry';

  /**
   * Permette di assegnare delle aziende a degli utenti.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerAssignRegistry()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerAssignRegistry$Response(params: IdentityControllerAssignRegistry$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse>> {
    return identityControllerAssignRegistry(this.http, this.rootUrl, params, context);
  }

  /**
   * Permette di assegnare delle aziende a degli utenti.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerAssignRegistry$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerAssignRegistry(params: IdentityControllerAssignRegistry$Params, context?: HttpContext): Observable<BaseResponse> {
    return this.identityControllerAssignRegistry$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse>): BaseResponse => r.body)
    );
  }

  /** Path part for operation `identityControllerAssignRole()` */
  static readonly IdentityControllerAssignRolePath = '/identity/role';

  /**
   * Permette di assegnare un ruolo a degli utenti.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerAssignRole()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerAssignRole$Response(params: IdentityControllerAssignRole$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse>> {
    return identityControllerAssignRole(this.http, this.rootUrl, params, context);
  }

  /**
   * Permette di assegnare un ruolo a degli utenti.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerAssignRole$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerAssignRole(params: IdentityControllerAssignRole$Params, context?: HttpContext): Observable<BaseResponse> {
    return this.identityControllerAssignRole$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse>): BaseResponse => r.body)
    );
  }

  /** Path part for operation `identityControllerGetMyself()` */
  static readonly IdentityControllerGetMyselfPath = '/identity/myself';

  /**
   * Restituisce la propria utenza.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerGetMyself()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerGetMyself$Response(params?: IdentityControllerGetMyself$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>> {
    return identityControllerGetMyself(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce la propria utenza.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerGetMyself$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerGetMyself(params?: IdentityControllerGetMyself$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserItem;
}> {
    return this.identityControllerGetMyself$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>): BaseResponse & {
'data'?: UserItem;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerUpdateMyself()` */
  static readonly IdentityControllerUpdateMyselfPath = '/identity/myself';

  /**
   * Modifica la propria utenza.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerUpdateMyself()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerUpdateMyself$Response(params: IdentityControllerUpdateMyself$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: LoginResponse;
}>> {
    return identityControllerUpdateMyself(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica la propria utenza.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerUpdateMyself$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerUpdateMyself(params: IdentityControllerUpdateMyself$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: LoginResponse;
}> {
    return this.identityControllerUpdateMyself$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: LoginResponse;
}>): BaseResponse & {
'data'?: LoginResponse;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerGetOne()` */
  static readonly IdentityControllerGetOnePath = '/identity/{id}';

  /**
   * Restituisce un utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerGetOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerGetOne$Response(params: IdentityControllerGetOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>> {
    return identityControllerGetOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce un utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerGetOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerGetOne(params: IdentityControllerGetOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserItem;
}> {
    return this.identityControllerGetOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>): BaseResponse & {
'data'?: UserItem;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerDelete()` */
  static readonly IdentityControllerDeletePath = '/identity/{id}';

  /**
   * Elimina un utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerDelete$Response(params: IdentityControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>> {
    return identityControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina un utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerDelete(params: IdentityControllerDelete$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserItem;
}> {
    return this.identityControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>): BaseResponse & {
'data'?: UserItem;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerUpdate()` */
  static readonly IdentityControllerUpdatePath = '/identity/{id}';

  /**
   * Modifica un utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerUpdate$Response(params: IdentityControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>> {
    return identityControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica un utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerUpdate(params: IdentityControllerUpdate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserItem;
}> {
    return this.identityControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>): BaseResponse & {
'data'?: UserItem;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerSetActive()` */
  static readonly IdentityControllerSetActivePath = '/identity/{id}/active';

  /**
   * Attiva o disattiva un utente.
   *
   * Disattivandolo non può più accedere e le sue sessioni vengono revocate; i dati e lo storico restano. Non si può disattivare il proprio utente.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerSetActive()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerSetActive$Response(params: IdentityControllerSetActive$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse>> {
    return identityControllerSetActive(this.http, this.rootUrl, params, context);
  }

  /**
   * Attiva o disattiva un utente.
   *
   * Disattivandolo non può più accedere e le sue sessioni vengono revocate; i dati e lo storico restano. Non si può disattivare il proprio utente.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerSetActive$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerSetActive(params: IdentityControllerSetActive$Params, context?: HttpContext): Observable<BaseResponse> {
    return this.identityControllerSetActive$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse>): BaseResponse => r.body)
    );
  }

  /** Path part for operation `identityControllerProfilePicture()` */
  static readonly IdentityControllerProfilePicturePath = '/identity/profile';

  /**
   * Foto profilo per utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerProfilePicture()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  identityControllerProfilePicture$Response(params: IdentityControllerProfilePicture$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>> {
    return identityControllerProfilePicture(this.http, this.rootUrl, params, context);
  }

  /**
   * Foto profilo per utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerProfilePicture$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  identityControllerProfilePicture(params: IdentityControllerProfilePicture$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserItem;
}> {
    return this.identityControllerProfilePicture$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserItem;
}>): BaseResponse & {
'data'?: UserItem;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerActivate()` */
  static readonly IdentityControllerActivatePath = '/identity/{id}/activate';

  /**
   * Attiva un utente dal confirmationCode.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerActivate()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerActivate$Response(params: IdentityControllerActivate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return identityControllerActivate(this.http, this.rootUrl, params, context);
  }

  /**
   * Attiva un utente dal confirmationCode.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerActivate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerActivate(params: IdentityControllerActivate$Params, context?: HttpContext): Observable<void> {
    return this.identityControllerActivate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `identityControllerLogin()` */
  static readonly IdentityControllerLoginPath = '/identity/session';

  /**
   * Login.
   *
   * Con X-Client-Auth: 2 restituisce anche il refresh token. Se l'utente ha la MFA attiva restituisce mfa_required + mfa_token invece dei token: si prosegue con /session/mfa (e /session/mfa/setup alla prima configurazione).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerLogin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerLogin$Response(params: IdentityControllerLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: SessionResponse;
}>> {
    return identityControllerLogin(this.http, this.rootUrl, params, context);
  }

  /**
   * Login.
   *
   * Con X-Client-Auth: 2 restituisce anche il refresh token. Se l'utente ha la MFA attiva restituisce mfa_required + mfa_token invece dei token: si prosegue con /session/mfa (e /session/mfa/setup alla prima configurazione).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerLogin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerLogin(params: IdentityControllerLogin$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: SessionResponse;
}> {
    return this.identityControllerLogin$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: SessionResponse;
}>): BaseResponse & {
'data'?: SessionResponse;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerForgotPassword()` */
  static readonly IdentityControllerForgotPasswordPath = '/identity/password/forgot';

  /**
   * Richiede il link di recupero password.
   *
   * Risponde sempre allo stesso modo, esista o no l'account: se l'email appartiene a un utente attivo gli invia un link valido pochi minuti.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerForgotPassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerForgotPassword$Response(params: IdentityControllerForgotPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
    return identityControllerForgotPassword(this.http, this.rootUrl, params, context);
  }

  /**
   * Richiede il link di recupero password.
   *
   * Risponde sempre allo stesso modo, esista o no l'account: se l'email appartiene a un utente attivo gli invia un link valido pochi minuti.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerForgotPassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerForgotPassword(params: IdentityControllerForgotPassword$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EmptyResponse;
}> {
    return this.identityControllerForgotPassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>): BaseResponse & {
'data'?: EmptyResponse;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerResetPassword()` */
  static readonly IdentityControllerResetPasswordPath = '/identity/password/reset';

  /**
   * Imposta la nuova password con il token ricevuto per email.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerResetPassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerResetPassword$Response(params: IdentityControllerResetPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
    return identityControllerResetPassword(this.http, this.rootUrl, params, context);
  }

  /**
   * Imposta la nuova password con il token ricevuto per email.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerResetPassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerResetPassword(params: IdentityControllerResetPassword$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EmptyResponse;
}> {
    return this.identityControllerResetPassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>): BaseResponse & {
'data'?: EmptyResponse;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerMfaSetup()` */
  static readonly IdentityControllerMfaSetupPath = '/identity/session/mfa/setup';

  /**
   * Prima configurazione MFA: genera il segreto per l’app autenticatore.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerMfaSetup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerMfaSetup$Response(params: IdentityControllerMfaSetup$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MfaSetupResponse;
}>> {
    return identityControllerMfaSetup(this.http, this.rootUrl, params, context);
  }

  /**
   * Prima configurazione MFA: genera il segreto per l’app autenticatore.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerMfaSetup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerMfaSetup(params: IdentityControllerMfaSetup$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: MfaSetupResponse;
}> {
    return this.identityControllerMfaSetup$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: MfaSetupResponse;
}>): BaseResponse & {
'data'?: MfaSetupResponse;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerMfaVerify()` */
  static readonly IdentityControllerMfaVerifyPath = '/identity/session/mfa';

  /**
   * Verifica il codice MFA (o conferma la prima configurazione) e apre la sessione.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerMfaVerify()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerMfaVerify$Response(params: IdentityControllerMfaVerify$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: SessionResponse;
}>> {
    return identityControllerMfaVerify(this.http, this.rootUrl, params, context);
  }

  /**
   * Verifica il codice MFA (o conferma la prima configurazione) e apre la sessione.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerMfaVerify$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerMfaVerify(params: IdentityControllerMfaVerify$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: SessionResponse;
}> {
    return this.identityControllerMfaVerify$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: SessionResponse;
}>): BaseResponse & {
'data'?: SessionResponse;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerRefreshSession()` */
  static readonly IdentityControllerRefreshSessionPath = '/identity/session/refresh';

  /**
   * Rinnova la sessione: restituisce un nuovo access token e un nuovo refresh token (il precedente non è più valido).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerRefreshSession()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerRefreshSession$Response(params: IdentityControllerRefreshSession$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: SessionResponse;
}>> {
    return identityControllerRefreshSession(this.http, this.rootUrl, params, context);
  }

  /**
   * Rinnova la sessione: restituisce un nuovo access token e un nuovo refresh token (il precedente non è più valido).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerRefreshSession$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerRefreshSession(params: IdentityControllerRefreshSession$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: SessionResponse;
}> {
    return this.identityControllerRefreshSession$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: SessionResponse;
}>): BaseResponse & {
'data'?: SessionResponse;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerLogout()` */
  static readonly IdentityControllerLogoutPath = '/identity/session/logout';

  /**
   * Chiude la sessione del dispositivo corrente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerLogout()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerLogout$Response(params?: IdentityControllerLogout$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
    return identityControllerLogout(this.http, this.rootUrl, params, context);
  }

  /**
   * Chiude la sessione del dispositivo corrente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerLogout$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerLogout(params?: IdentityControllerLogout$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EmptyResponse;
}> {
    return this.identityControllerLogout$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>): BaseResponse & {
'data'?: EmptyResponse;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerResetMfa()` */
  static readonly IdentityControllerResetMfaPath = '/identity/{id}/mfa/reset';

  /**
   * Reimposta la MFA di un utente: elimina la configurazione dell'autenticatore e revoca le sue sessioni.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerResetMfa()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerResetMfa$Response(params: IdentityControllerResetMfa$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
    return identityControllerResetMfa(this.http, this.rootUrl, params, context);
  }

  /**
   * Reimposta la MFA di un utente: elimina la configurazione dell'autenticatore e revoca le sue sessioni.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerResetMfa$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerResetMfa(params: IdentityControllerResetMfa$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EmptyResponse;
}> {
    return this.identityControllerResetMfa$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>): BaseResponse & {
'data'?: EmptyResponse;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerDevices()` */
  static readonly IdentityControllerDevicesPath = '/identity/{id}/devices';

  /**
   * Sessioni e dispositivi ricordati di un utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerDevices()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerDevices$Response(params: IdentityControllerDevices$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserDeviceListResponse;
}>> {
    return identityControllerDevices(this.http, this.rootUrl, params, context);
  }

  /**
   * Sessioni e dispositivi ricordati di un utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerDevices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerDevices(params: IdentityControllerDevices$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserDeviceListResponse;
}> {
    return this.identityControllerDevices$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserDeviceListResponse;
}>): BaseResponse & {
'data'?: UserDeviceListResponse;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerRevokeDevice()` */
  static readonly IdentityControllerRevokeDevicePath = '/identity/{id}/devices/{device_id}';

  /**
   * Revoca una sessione/dispositivo di un utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerRevokeDevice()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerRevokeDevice$Response(params: IdentityControllerRevokeDevice$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
    return identityControllerRevokeDevice(this.http, this.rootUrl, params, context);
  }

  /**
   * Revoca una sessione/dispositivo di un utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerRevokeDevice$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  identityControllerRevokeDevice(params: IdentityControllerRevokeDevice$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EmptyResponse;
}> {
    return this.identityControllerRevokeDevice$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>): BaseResponse & {
'data'?: EmptyResponse;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerUserHasGrants()` */
  static readonly IdentityControllerUserHasGrantsPath = '/identity/userHasGrants';

  /**
   * Verifica che l'utente del JWT abbia i grant richiesti.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerUserHasGrants()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerUserHasGrants$Response(params: IdentityControllerUserHasGrants$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return identityControllerUserHasGrants(this.http, this.rootUrl, params, context);
  }

  /**
   * Verifica che l'utente del JWT abbia i grant richiesti.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerUserHasGrants$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerUserHasGrants(params: IdentityControllerUserHasGrants$Params, context?: HttpContext): Observable<void> {
    return this.identityControllerUserHasGrants$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `identityControllerChangePassword()` */
  static readonly IdentityControllerChangePasswordPath = '/identity/changePassword';

  /**
   * Utilizzato per effettuare il cambio password dell'utente autenticato.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerChangePassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerChangePassword$Response(params: IdentityControllerChangePassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return identityControllerChangePassword(this.http, this.rootUrl, params, context);
  }

  /**
   * Utilizzato per effettuare il cambio password dell'utente autenticato.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerChangePassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerChangePassword(params: IdentityControllerChangePassword$Params, context?: HttpContext): Observable<void> {
    return this.identityControllerChangePassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `identityControllerConnectUsers()` */
  static readonly IdentityControllerConnectUsersPath = '/identity/{user_id}/agreements';

  /**
   * Connette gli agreement ad un utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerConnectUsers()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerConnectUsers$Response(params: IdentityControllerConnectUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
    return identityControllerConnectUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * Connette gli agreement ad un utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerConnectUsers$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerConnectUsers(params: IdentityControllerConnectUsers$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EmptyResponse;
}> {
    return this.identityControllerConnectUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>): BaseResponse & {
'data'?: EmptyResponse;
} => r.body)
    );
  }

  /** Path part for operation `identityControllerConnectReports()` */
  static readonly IdentityControllerConnectReportsPath = '/identity/{user_id}/reports';

  /**
   * Connette i report ad un utente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `identityControllerConnectReports()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerConnectReports$Response(params: IdentityControllerConnectReports$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
    return identityControllerConnectReports(this.http, this.rootUrl, params, context);
  }

  /**
   * Connette i report ad un utente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `identityControllerConnectReports$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  identityControllerConnectReports(params: IdentityControllerConnectReports$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EmptyResponse;
}> {
    return this.identityControllerConnectReports$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>): BaseResponse & {
'data'?: EmptyResponse;
} => r.body)
    );
  }

}
